import React from 'react';
import ProductContainer from '../Container';
import { ProductCardProps } from '../types';
import CardHeadImage from '../meta/card-head/card-head-image';
import CardHeadSoldOut from '../meta/card-head/card-head-soldout';
import CardBodyTopTag from '../meta/card-body/card-body-top-tag';
import CardBodyProductName from '../meta/card-body/card-body-product-name';
import CardBodyBottomInfo from '../meta/card-body/card-body-bottom-info';
import CardBodyMetrics from '../meta/card-body/card-body-metrics';
import CardHeadLabel from '../meta/card-head/card-head-label';
import ProductPriceV2 from './meta/product-price-v2';
import ProductBrandImg from './meta/product-brand-img';
import ProductClaimedPriority from '../meta/card-body/product-claimed-priority';
import ProductAddCart from '../meta/add-cart';
import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';
import EnchancedFavorite from '../meta/enchanced-favorite';

const SkuVerticalProductCard: React.FC<Partial<ProductCardProps>> = props => {
  const { data, mainContentClassName = 'px-2 pt-3 pb-5' } = props;

  const { t } = useTranslation('common');

  return (
    // <ProductContainer className="p-0 !rounded-none bg-transparent" {...props}>
    <ProductContainer
      className=""
      interactiveSlot={
        <div className="absolute left-0 top-0 w-full h-full pointer-events-none">
          <EnchancedFavorite className="top-2" {...props} />
        </div>
      }
      {...props}>
      <div className="relative w-full pt-[100%] box-border overflow-hidden">
        <CardHeadImage
          {...props}
          imageProps={{
            boxClassName: 'rounded-400 bg-product-bg-img-tint border-solid border-input-100-hairline-default border'
          }}
        />
        <CardHeadLabel {...props} showFavorite={false} showBigOffLabel={true} bigOffLabelCls="items-start top-0" />
        <CardHeadSoldOut {...props} className="rounded-400" />
        {/* 添加品牌图片 */}
        <div className={twMerge('absolute right-2 bottom-2', props.brandImg?.containerClassName)}>
          <ProductBrandImg {...props} />
        </div>
      </div>
      {/* <div className="flex-1 flex items-stretch justify-between flex-col mx-2.5 my-1.5"> */}
      <div className={mainContentClassName}>
        {/* <div className="my-[5px]"> */}
        <ProductPriceV2 {...props} />
        {/* </div> */}

        <ProductClaimedPriority {...props} />
        <CardBodyTopTag {...props} />

        <CardBodyProductName
          {...props}
          className={twMerge('mb-2', props.productNameContainerCls)}
          productNameClass={twMerge('enki-body-base-medium', props.productNameClass)}
          isShow3Lines={false}
        />

        <ProductAddCart
          addCartBtnClassName="static w-full"
          className={twMerge(
            'bg-btn-primary-bg rounded-full relative h-[40px] px-0 text-atc-mini-fg-added',
            props.addCartBtnTextCls || 'enki-body-sm-medium'
          )}
          remindedFontClassName={props.addCartBtnTextCls || 'enki-body-sm-medium'}
          remindFontClassName={props.addCartBtnTextCls || 'enki-body-sm-medium'}
          changeOtherDayFontClassName={props.addCartBtnTextCls || 'enki-body-sm-medium'}
          purchaseClassName={props.purchaseClassName}
          text={t('add_to_cart')}
          data={data}
          cardType="vertical"
          {...props}
          isInProductCard
          isHoriziontal
        />
        <div className="mt-3">
          <CardBodyBottomInfo
            {...props}
            className="mt-0 mb-0"
            productTagClassNames="gap-x-0.5"
            tagClassName="gap-y-2"
            tagItemClassName="mb-0"
            mainBottomContentCls="gap-y-2"
            etaClassName="enki-body-xs-medium"
            shipsFromClassName="enki-body-xs-medium"
          />
        </div>
        <CardBodyMetrics {...props} />
        {props.children}
      </div>
    </ProductContainer>
  );
};

export default SkuVerticalProductCard;
